import {
  DashboardSection,
  DashboardTab,
} from '@constants/Dashboard/dashboard.enums'

/** Huddle sections hidden until real APIs exist. Remove a title from this list to show it again. */
export const HUDDLE_TEMPORARILY_HIDDEN_SECTIONS = [
  DashboardSection.FollowUpsFromYesterday,
  DashboardSection.PreparationForTomorrow,
  DashboardSection.OverdueActions,
] as const

export const HUDDLE_DEFAULT_HIDDEN_SECTIONS = new Set<string>(
  HUDDLE_TEMPORARILY_HIDDEN_SECTIONS,
)

/** Overview sections hidden until real APIs exist. */
export const OVERVIEW_TEMPORARILY_HIDDEN_SECTIONS = [
  DashboardSection.Tasks,
] as const

export const OVERVIEW_DEFAULT_HIDDEN_SECTIONS = new Set<string>(
  OVERVIEW_TEMPORARILY_HIDDEN_SECTIONS,
)

/** Operations sections hidden until real APIs exist. */
export const OPERATIONS_TEMPORARILY_HIDDEN_SECTIONS = [
  DashboardSection.ExpensesBreakdown,
] as const

export const OPERATIONS_DEFAULT_HIDDEN_SECTIONS = new Set<string>(
  OPERATIONS_TEMPORARILY_HIDDEN_SECTIONS,
)

const TEMPORARILY_HIDDEN_SECTIONS_BY_TAB: Record<
  string,
  ReadonlySet<string>
> = {
  [DashboardTab.Huddle]: HUDDLE_DEFAULT_HIDDEN_SECTIONS,
  [DashboardTab.Overview]: OVERVIEW_DEFAULT_HIDDEN_SECTIONS,
  [DashboardTab.Operations]: OPERATIONS_DEFAULT_HIDDEN_SECTIONS,
}

/** Drops section titles that are hidden until a real API exists. */
export function omitTemporarilyHiddenSections(
  tab: string,
  names: readonly string[],
): string[] {
  const hidden = TEMPORARILY_HIDDEN_SECTIONS_BY_TAB[tab]
  if (!hidden) return [...names]
  return names.filter((name) => !hidden.has(name))
}
